import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

import { appendRouteQuery } from 'utils/appendRouteQuery';

export default function MigraineV4Index() {
  const router = useRouter();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('skip_q3') === 'true') {
      localStorage.setItem('migraine_v4_skip_q3', 'true');
    }
    const paywallType = params.get('paywall_type');
    if (paywallType) {
      localStorage.setItem('migraine_v4_paywall_type', paywallType);
    }
    const paywallScreen = params.get('paywall_screen');
    if (paywallScreen) {
      localStorage.setItem('migraine_v4_paywall_screen', paywallScreen);
    }
    const query = Object.fromEntries(params.entries());
    router.push(appendRouteQuery('/survey/migraine-v4/opening/s1-hook', query));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
